module.exports = __webpack_public_path__ + "img/u5273.96a5e0fe.svg";